import { render, staticRenderFns } from "./HeaderSelection.vue?vue&type=template&id=24b6ebfe&scoped=true"
import script from "./HeaderSelection.vue?vue&type=script&lang=js"
export * from "./HeaderSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6ebfe",
  null
  
)

export default component.exports